import React from 'react'
import createSvgIcon from './utils/createSvgIcon'

export default createSvgIcon(
  <React.Fragment>
    <path d="M18.25 2A3.75 3.75 0 0122 5.75v12.5A3.75 3.75 0 0118.25 22H5.75A3.75 3.75 0 012 18.25V5.75A3.75 3.75 0 015.75 2h12.5zm1.25 5.952h-15V18.25c0 .69.56 1.25 1.25 1.25h12.5c.69 0 1.25-.56 1.25-1.25V7.952zm-8.44 1.985l.944 1.746.967-1.746h2.444l-1.95 3.048 2.027 3.175h-2.439l-1.049-1.89-1.044 1.89H8.516l2.005-3.175-1.9-3.048h2.439z" />
  </React.Fragment>,
  'Value',
)
